import { Group } from "./group";
import { TabProfile } from 'src/app/services/API.service';

interface AwsUser {
    Username: string;
    Enabled: boolean;
    UserStatus: string;
    UserCreateDate: string;
    UserLastModifiedDate: string;
    Attributes: Attribute[];
}

interface Attribute {
    Name: string;
    Value: string;
}

interface AwsGroup {
    GroupName: string;
    Precedence: number;
}

export class User {
    Username: string;
    AccountStatus: string;
    Enabled: boolean;
    Status: string;
    Email: string;
    Emailverified: boolean;
    Tabs: TabProfile[] = [];
    Groups: Group[] = [];
    CreatedDate: Date;
    LastModifiedDate: Date;

    constructor(data: AwsUser) {
        this.Username = data.Username;
        this.Status = data.UserStatus;
        this.CreatedDate = new Date(data.UserCreateDate);
        this.LastModifiedDate = new Date(data.UserLastModifiedDate);

        this.setEnabled(data.Enabled);

        data.Attributes.forEach(n => {
            switch (n.Name) {
                case 'email':
                    this.Email = n.Value;
                    break;

                case 'email_verified':
                    this.Emailverified = n.Value === 'true' ? true : false;
                    break;

                default:
                    break;
            }
        });
    }

    setEnabled(data) {
        this.Enabled = data;

        if (data) {
            this.AccountStatus = 'Enabled';
        } else {
            this.AccountStatus = 'Disabled';
        }
    }

    addGroups(groups: AwsGroup[]) {
        groups.forEach(n => {
            this.Groups.push(new Group(n));
        });
    }
}
